import { TFunction } from 'i18next';
import * as yup from 'yup';

import { CountryISOCodes } from 'common/countries';
import { isValidPhoneNumber } from 'utils/phone';

import { isValidUKPostcode } from './address';
import { EMAIL_REGEX } from './helpers';

export const stringRequired = (t: TFunction, fieldName: string) =>
  yup
    .string()
    .trim()
    .required(t('common:validations.required', { name: t(fieldName) }));

export const validateCity = (t: TFunction) =>
  yup
    .string()
    .trim()
    .when('countryIsocode', {
      is: CountryISOCodes.UnitedKingdom,
      then: (schema) =>
        schema.required(t('common:fields.town.validation.required')),
      otherwise: (schema) =>
        schema.required(t('common:fields.city.validation.required')),
    });

export const validatePostalCode = (t: TFunction) =>
  yup
    .string()
    .trim()
    .when('countryIsocode', {
      is: CountryISOCodes.UnitedKingdom,
      then: (schema) =>
        schema
          .required(t('common:fields.postcode.validation.required'))
          .test(
            'uk-postcode',
            t('common:validations.postcode'),
            isValidUKPostcode,
          ),
      otherwise: (schema) =>
        schema.required(t('common:fields.postal.validation.required')),
    });

export const validateState = (t: TFunction) =>
  yup
    .string()
    .trim()
    .when('countryIsocode', {
      is: CountryISOCodes.UnitedKingdom,
      then: (schema) => schema.notRequired(),
      otherwise: (schema) =>
        schema.required(t('common:fields.province.validation.required')),
    });

export const validateEmail = (
  t: TFunction,
  fieldName = 'common:fields.email.label',
) =>
  yup
    .string()
    .trim()
    .required(t('common:validations.required', { name: t(fieldName) }))
    .matches(EMAIL_REGEX, t('common:validations.email'));

export const validatePhone = (
  t: TFunction,
  fieldName = 'common:fields.phone.label',
) =>
  yup
    .string()
    .trim()
    .test('phone', t('common:validations.phone'), function (value) {
      if (!value) return true;

      return isValidPhoneNumber(value, this.parent.alpha2Code || 'US');
    })
    .required(t('common:validations.required', { name: t(fieldName) }));
